import React from 'react';
import { getSubheading, truncateText } from 'utils/text';
import { Container } from './styles';

const NavigationItem = props => {
  const { icon, title, excerpt, multiLineTitle, selected, titleHeight } = props || {};
  const iconUrl = icon?.image?.file?.url;

  return (
    <Container titleHeight={titleHeight} multiLineTitle={multiLineTitle} selected={selected}>
      <div className="in-page-features-v3--image">
        <img src={iconUrl} />
      </div>
      <div className="in-page-features-v3--copy">
        <p className="in-page-features-v3--title">{truncateText(title, 19)}</p>
        {excerpt && (
          <p className="in-page-features-v3--sub-title">{getSubheading(null, excerpt.json)}</p>
        )}
      </div>
    </Container>
  );
};

export default NavigationItem;
